import React from 'react';

/**
 * Linked matter display card.
 * @param {{ label?: string, name: string, number: string, status: string, practiceArea?: string }} props
 */
export default function MatterCard({ label = 'Linked Matter', name, number, status, practiceArea }) {
    const statusClass = status?.toLowerCase() || 'open';
    const paDisplay = typeof practiceArea === 'object' && practiceArea !== null
        ? practiceArea.name
        : practiceArea;

    return (
        <div className="matter-card">
            <div className="matter-label">{label}</div>
            <div className="matter-name">{name}</div>
            <div className="matter-meta">
                <span className="matter-num">{number}</span>
                <span className={`badge ${statusClass}`}>{status}</span>
                {paDisplay && <span className="badge court">{paDisplay}</span>}
            </div>
        </div>
    );
}
